// Endpoint paths on wuzi-portal-bff (relative to REACT_APP_API_URL + '/bff', see src/services/api.ts)
// for the payment links feature. The BFF owns authenticating against the downstream payments
// gateway and translating these calls — this app only ever sends its own Keycloak bearer token,
// attached automatically by the axios interceptor in src/services/api.ts.
export const PAYMENT_LINKS_ENDPOINTS = {
  create: '/payment-links-view/link',
  // Passthrough CRUDO de Broxel (GET bff/payment-links-view/broxel/raw). Se usa tanto
  // para "Últimos Links Generados" (page 0, size chico) como para el listado completo
  // de Consulta (paginado, size 10): trae la forma tal cual de Broxel, no la BD local.
  broxelRaw: '/payment-links-view/broxel/raw',
  // Passthrough CRUDO de un solo link por id (GET bff/payment-links-view/broxel/raw/:id).
  // Se usa para el ícono de "Compartir" de la Consulta: el id es el mismo que ya viene en
  // cada registro de `broxelRaw`. Contrato PROPUESTO (misma forma que un registro de la
  // lista); falta confirmar contra el BFF real.
  broxelRawById: (id: string | number) => `/payment-links-view/broxel/raw/${id}`,
} as const;
